import React from 'react';


// examples
const Dashboard = React.lazy(() => import('./views/dashboard/Dashboard'));
const Profile = React.lazy(() => import('./views/profile/Profile'));

const UserList = React.lazy(() => import('./views/users/List'));
const CreateUser = React.lazy(() => import('./views/users/Create'));
const EditUser = React.lazy(() => import('./views/users/Edit'));

const EmployeeList = React.lazy(() => import('./views/employees/List'));
const GroupList = React.lazy(() => import('./views/employees/GroupList'));

const CustomerList = React.lazy(() => import('./views/customers/List'));
const CreateCustomer = React.lazy(() => import('./views/customers/Create'));
const EditCustomer = React.lazy(() => import('./views/customers/Edit'));


const PosterList = React.lazy(() => import('./views/posters/List'));


const TemplateList = React.lazy(() => import('./views/templates/List'));
const EmailTemplateList = React.lazy(() => import('./views/templates/email/List'));
const CreateEmailTemplate = React.lazy(() => import('./views/templates/email/Create'));
const EditEmailTemplate = React.lazy(() => import('./views/templates/email/Edit'));
const DuplicateEmailTemplate = React.lazy(() => import('./views/templates/email/Duplicate'));
// const SystemEmailers = React.lazy(() => import('./views/templates/email/SystemEmailers'));

const TrainingModuleList = React.lazy(() => import('./views/elearning/library/List'));
const CreateTrainingModule = React.lazy(() => import('./views/elearning/library/Create'));
const EditTrainingModule = React.lazy(() => import('./views/elearning/library/Edit'));


const Settings = React.lazy(() => import('./views/settings/configuration/List'));
const ConfigureSMTPDetails = React.lazy(() => import('./views/settings/SMTP/Configure'));
const WaffleMenuConfig = React.lazy(() => import('./views/settings/waffle-menu/List'));
const WhatsappSenders = React.lazy(() => import('./views/settings/whatsapp/Senders'));
const ApiKeys = React.lazy(() => import('./views/settings/api-keys/List'));
const AiConfiguration = React.lazy(() => import('./views/settings/ai/Configure'));
const CustomerAiConfig = React.lazy(() => import('./views/customers/AiConfig'));

const SystemTemplateList = React.lazy(() => import('./views/system_templates/List'));
const CreateSystemTemplate = React.lazy(() => import('./views/system_templates/Create'));
const EditSystemTemplate = React.lazy(() => import('./views/system_templates/Edit'));

const SMSTemplateList = React.lazy(() => import('./views/templates/sms/List'));
const CreateSMSTemplate = React.lazy(() => import('./views/templates/sms/Create'));
const EditSMSTemplate = React.lazy(() => import('./views/templates/sms/Edit'));
const DuplicateSMSTemplate = React.lazy(() => import('./views/templates/sms/Duplicate'));

const VoiceTemplateList = React.lazy(() => import('./views/templates/voice/List'));
const CreateVoiceTemplate = React.lazy(() => import('./views/templates/voice/Create'));
const EditVoiceTemplate = React.lazy(() => import('./views/templates/voice/Edit'));

const LandingPageList = React.lazy(() => import('./views/landing_pages/List'));
const CreateLandingPage = React.lazy(() => import('./views/landing_pages/Create'));

const EmailCampaignList = React.lazy(() => import('./views/campaigns/email/List'));
const CreateEmailCampaign = React.lazy(() => import('./views/campaigns/email/Create'));
const EditEmailCampaign = React.lazy(() => import('./views/campaigns/email/Edit'));

const SMSCampaignList = React.lazy(() => import('./views/campaigns/sms/List'));
const WhatsappCampaignList = React.lazy(() => import('./views/campaigns/whatsapp/List'));
const CreateSMSCampaign = React.lazy(() => import('./views/campaigns/email/Create'));
const EditSMSCampaign = React.lazy(() => import('./views/campaigns/sms/Edit'));

const VoiceCampaignList = React.lazy(() => import('./views/campaigns/voice/List'));
const CreateVoiceCampaign = React.lazy(() => import('./views/campaigns/email/Create'));
const CreateWhatsappCampaign = React.lazy(() => import('./views/campaigns/email/Create'));
const CreateAttachmentCampaign = React.lazy(() => import('./views/campaigns/email/Create'));

const TrainingCampaignList = React.lazy(() => import('./views/campaigns/training/List'));
const CreateTrainingCampaign = React.lazy(() => import('./views/campaigns/training/Create'));

const CampaignDashboard = React.lazy(() => import('./views/campaigns/Dashboard'));
const EmailCampaignReport = React.lazy(() => import('./views/campaigns/email/Report'));
const AttachmentCampaignReport = React.lazy(() => import('./views/campaigns/attachment/Report'));
const TrainingCampaignReport = React.lazy(() => import('./views/campaigns/training/Report'));
const SMSCampaignReport = React.lazy(() => import('./views/campaigns/sms/Report'));
const VoiceCampaignReport = React.lazy(() => import('./views/campaigns/voice/Report'));

const EmailCampaignUsers = React.lazy(() => import('./views/campaigns/email/Users'));
const TrainingCampaignUsers = React.lazy(() => import('./views/campaigns/training/Users'));
const TrainingReminderList = React.lazy(() => import('./views/campaigns/training/ReminderList'));
const SMSCampaignUsers = React.lazy(() => import('./views/campaigns/sms/Users'));
const VoiceCampaignUsers = React.lazy(() => import('./views/campaigns/voice/Users'));
// const Instructionmanual = React.lazy(() => import('./views/tutorial/List'));
const Instructionmanual = React.lazy(() => import('./views/tutorial/InstructionList'));

const NewsFeeds = React.lazy(() => import('./views/Feeds/List'));

const PhishingReportList = React.lazy(() => import('./views/reporter/List'));

const CategoriesList = React.lazy(() => import('./views/categories/List'));

const LandingPage_new = React.lazy(() => import('./views/landingPage_new/View'))
const CreateLandingPage_new = React.lazy(() => import('./views/landingPage_new/CreatePage'))
const EditLandingPage_new = React.lazy(() => import('./views/landingPage_new/EditPage'))

const Poster_New = React.lazy(() => import('./views/poster_new/ViewPoster'))

const NotFound = React.lazy(() => import('./views/pages/page404/Page404'));

const NotAccess = React.lazy(() => import('./views/pages/page403/Page403'));// Create a NotFound component

const routes = [
	{ path: '/dashboard', name: 'Dashboard', element: Dashboard, accessPermission: [0, 1, 2, 3, 4] },
	{ path: '/profile', name: 'Profile', element: Profile, accessPermission: [0, 1, 2, 3, 4] },

	{ path: '/users', name: 'Platform Users', element: UserList, accessPermission: [0, 1] },
	{ path: '/users/create', name: 'Create Platform User', element: CreateUser, accessPermission: [0, 1] },
	{ path: '/users/:userId/edit', name: 'Edit User', element: EditUser, accessPermission: [0, 1] },

	{ path: '/address-book', name: 'Manage Users', element: EmployeeList, accessPermission: [1, 2, 3, 4] },
	{ path: '/groups', name: 'Manage Groups', element: GroupList, accessPermission: [1, 2, 3, 4] },
	// { path: '/create/user', name: 'Create Platform User', element: CreateUser, accessPermission: [0,1,2,3] },

	{ path: '/customers', name: 'Customers', element: CustomerList, accessPermission: [0, 1, 2] },
	{ path: '/customers/create', name: 'Create Customer', element: CreateCustomer, accessPermission: [0, 1, 2] },
	{ path: '/customers/:customerId/edit', name: 'Update Customer', element: EditCustomer, accessPermission: [0, 1, 2] },
	{ path: '/customers/:customerId/users', name: 'Users List', element: UserList, accessPermission: [0, 1, 2] },
	{ path: '/customers/:customerId/users/create', name: 'Create Platform User', element: CreateUser, accessPermission: [0, 1, 2] },

	// Posters
	{ path: '/posters', name: 'Cyber Security Posters', element: PosterList, accessPermission: [0, 1, 2, 3, 4] },

	// Templates
	{ path: '/templates', name: 'Phishing Material', element: TemplateList, accessPermission: [1, 2, 3, 4] },
	{ path: '/email/templates', name: 'Phishing Material', element: EmailTemplateList, accessPermission: [1, 2, 3, 4] },
	{ path: '/create/email/template', name: 'Create Phishing Template', element: CreateEmailTemplate, accessPermission: [1, 2, 3, 4] },
	{ path: '/email/templates/:templateId/edit', name: 'Edit Email Template', element: EditEmailTemplate, accessPermission: [1, 2, 3, 4] },
	{ path: '/email/templates/:templateId/duplicate', name: 'Duplicate Email Template', element: DuplicateEmailTemplate, accessPermission: [1, 2, 3, 4] },
	// { path: '/system-emailers', name: 'Customize System Notifiers', element: SystemEmailers, accessPermission: [1,2,3] },

	{ path: '/sms/templates', name: 'SMS Templates', element: SMSTemplateList, accessPermission: [1, 2, 3, 4] },
	{ path: '/create/sms/template', name: 'Create SMS Template', element: CreateSMSTemplate, accessPermission: [1, 2, 3, 4] },
	{ path: '/sms/templates/:templateId/edit', name: 'Edit SMS Template', element: EditSMSTemplate, accessPermission: [1, 2, 3, 4] },
	{ path: '/sms/templates/:templateId/duplicate', name: 'Duplicate SMS Template', element: DuplicateSMSTemplate, accessPermission: [1, 2, 3, 4] },

	{ path: '/voice/templates', name: 'Voice Templates', element: VoiceTemplateList, accessPermission: [1, 2, 3, 4] },
	{ path: '/create/voice/template', name: 'Create Voice Template', element: CreateVoiceTemplate, accessPermission: [1, 2, 3, 4] },
	{ path: '/voice/templates/:templateId/edit', name: 'Edit Voice Template', element: EditVoiceTemplate, accessPermission: [1, 2, 3, 4] },

	{ path: '/system/templates', name: 'System Notifiers', element: SystemTemplateList, accessPermission: [0, 1, 2, 3, 4] },
	{ path: '/create/system/template', name: 'Create System Template', element: CreateSystemTemplate, accessPermission: [0, 1] },
	{ path: '/system/templates/:templateId/customize', name: 'Customize System Template', element: EditSystemTemplate, accessPermission: [0, 1, 2, 3] },

	// Training Modules
	{ path: '/training-modules', name: 'Training Modules', element: TrainingModuleList, accessPermission: [1, 2, 3, 4] },
	{ path: '/create/training-module', name: 'Create Training Module', element: CreateTrainingModule, accessPermission: [1, 2, 3, 4] },
	{ path: '/training-modules/:trainingId/edit', name: 'Edit Training Module', element: EditTrainingModule, accessPermission: [1, 2, 3, 4] },

	// Campaigns
	{ path: '/email/campaigns', name: 'Email Campaigns', element: EmailCampaignList, accessPermission: [1, 2, 3, 4] },
	{ path: '/email/campaigns/create', name: 'Create Email Campaign', element: CreateEmailCampaign, accessPermission: [1, 2, 3, 4] },
	{ path: '/email-training/campaigns/create', name: 'Create Email + Training Campaign', element: CreateEmailCampaign, accessPermission: [1, 2, 3, 4] },
	{ path: '/email/campaigns/:campaignId/edit', name: 'Edit', element: EditEmailCampaign, accessPermission: [1, 2, 3, 4] },
	{ path: '/training/campaigns/:campaignId/edit', name: 'Edit', element: EditEmailCampaign, accessPermission: [1, 2, 3, 4] },

	{ path: '/sms/campaigns', name: 'SMS Campaigns', element: SMSCampaignList, accessPermission: [1, 2, 3, 4] },
	{ path: '/sms/campaigns/create', name: 'Create SMS Campaign', element: CreateSMSCampaign, accessPermission: [1, 2, 3, 4] },
	{ path: '/sms-training/campaigns/create', name: 'Create SMS + Training Campaign', element: CreateSMSCampaign, accessPermission: [1, 2, 3, 4] },
	{ path: '/sms/campaigns/:campaignId/edit', name: 'Edit', element: EditSMSCampaign, accessPermission: [1, 2, 3, 4] },

	{ path: '/voice/campaigns', name: 'Voice Campaigns', element: VoiceCampaignList, accessPermission: [1, 2, 3, 4] },
	{ path: '/voice/campaigns/create', name: 'Create Voice Campaign', element: CreateVoiceCampaign, accessPermission: [1, 2, 3, 4] },

	{ path: '/whatsapp/campaigns', name: 'WhatsApp Campaigns', element: WhatsappCampaignList, accessPermission: [1, 2, 3, 4] },
	{ path: '/whatsapp/campaigns/create', name: 'Create Whatsapp Campaign', element: CreateWhatsappCampaign, accessPermission: [1, 2, 3, 4] },
	{ path: '/whatsapp/campaigns/:campaignId/edit', name: 'Edit', element: EditSMSCampaign, accessPermission: [1, 2, 3, 4] },

	{ path: '/training/campaigns', name: 'Training Campaigns', element: TrainingCampaignList, accessPermission: [1, 2, 3, 4] },
	{ path: '/training/campaigns/create', name: 'Create Training Campaign', element: CreateTrainingCampaign, accessPermission: [1, 2, 3, 4] },

	{ path: '/attachment/campaigns/create', name: 'Create Attachment Campaign', element: CreateAttachmentCampaign, accessPermission: [1, 2, 3, 4] },

	// Reports
	{ path: '/campaigns', name: 'Campaign Dashboard', element: CampaignDashboard, accessPermission: [1, 2, 3, 4] },
	{ path: '/campaigns/create', name: 'Create Campaigns', element: CreateEmailCampaign, accessPermission: [1, 2, 3, 4] },

	{ path: '/email/campaigns/:campaignId/report', name: 'Campaign Report', element: EmailCampaignReport, accessPermission: [1, 2, 3, 4] },
	{ path: '/attachment/campaigns/:campaignId/report', name: 'Campaign Report', element: AttachmentCampaignReport, accessPermission: [1, 2, 3, 4] },
	{ path: '/sms/campaigns/:campaignId/report', name: 'Campaign Report', element: SMSCampaignReport, accessPermission: [1, 2, 3, 4] },
	{ path: '/voice/campaigns/:campaignId/report', name: 'Campaign Report', element: VoiceCampaignReport, accessPermission: [1, 2, 3, 4] },
	{ path: '/whatsapp/campaigns/:campaignId/report', name: 'Campaign Report', element: SMSCampaignReport, accessPermission: [1, 2, 3, 4] },
	{ path: '/training/campaigns/:campaignId/report', name: 'Campaign Report', element: TrainingCampaignReport, accessPermission: [1, 2, 3, 4] },

	// Campaign Users
	{ path: '/email/campaigns/:campaignId/users', name: 'Campaign Users', element: EmailCampaignUsers, accessPermission: [1, 2, 3, 4] },
	{ path: '/attachment/campaigns/:campaignId/users', name: 'Campaign Users', element: EmailCampaignUsers, accessPermission: [1, 2, 3, 4] },
	{ path: '/training/campaigns/:campaignId/users', name: 'Campaign Users', element: TrainingCampaignUsers, accessPermission: [1, 2, 3, 4] },
	{ path: '/training/campaigns/:campaignId/reminders', name: 'Reminder List', element: TrainingReminderList, accessPermission: [1, 2, 3, 4] },
	{ path: '/sms/campaigns/:campaignId/users', name: 'Campaign Users', element: SMSCampaignUsers, accessPermission: [1, 2, 3, 4] },
	{ path: '/voice/campaigns/:campaignId/users', name: 'Campaign Users', element: VoiceCampaignUsers, accessPermission: [1, 2, 3, 4] },
	{ path: '/whatsapp/campaigns/:campaignId/users', name: 'Campaign Users', element: SMSCampaignUsers, accessPermission: [1, 2, 3, 4] },

	{ path: '/landing-pages', name: 'Phishing Websites', element: LandingPageList, accessPermission: [0, 1] },
	{ path: '/create/landing-page', name: 'Create Landing Page', element: CreateLandingPage, accessPermission: [0, 1] },
	//Instructionmanual
	{ path: '/Instructionmanual', name: 'Instruction Manual', element: Instructionmanual, accessPermission: [1, 2, 3, 4] },

	{ path: '/Newsfeeds', name: 'News Feeds', element: NewsFeeds, accessPermission: [1, 2, 3, 4] },

	// Settings
	{ path: '/settings', name: 'Settings', element: Settings, accessPermission: [0, 1, 2, 3, 4] },
	{ path: '/configure-smtp', name: 'Configure SMTP', element: ConfigureSMTPDetails, accessPermission: [0, 1, 2, 3, 4] },
	{ path: '/settings/waffle-menu', name: 'Waffle Menu Config', element: WaffleMenuConfig, accessPermission: [0, 1] },
	{ path: '/settings/whatsapp-senders', name: 'WhatsApp Senders', element: WhatsappSenders, accessPermission: [0, 1, 2] },
	{ path: '/settings/api-keys', name: 'API Keys', element: ApiKeys, accessPermission: [0, 1, 2, 3, 4] },
	{ path: '/settings/ai-configuration', name: 'AI Configuration', element: AiConfiguration, accessPermission: [0, 1, 2] },

	// AI Token Limits (admin only)
	{ path: '/customers/:customerId/ai-config', name: 'AI Configuration', element: CustomerAiConfig, accessPermission: [0, 1] },


	// reporter
	{ path: '/phish/reports', name: 'Phishing Reports', element: PhishingReportList, accessPermission: [1, 2, 3, 4] },

	//category create
	{ path: '/categories-operations', name: 'Categories', element: CategoriesList, accessPermission: [0, 1] },

	//LandingPage_New
	{ path: '/manage/landing-pages', name: 'Landing Pages', element: LandingPage_new, accessPermission: [0, 1, 2, 3] },
	{ path: '/manage/landing-pages/create', name: 'Create Landing Page', element: CreateLandingPage_new, accessPermission: [0, 1, 2, 3] },
	{ path: '/manage/landing-pages/:landingPageId/edit', name: 'Edit Landing Page', element: EditLandingPage_new, accessPermission: [0, 1, 2, 3] },

	//poster_new
	{ path: '/manage/posters', name: 'Posters', element: Poster_New, accessPermission: [0, 1, 2, 3, 4] },

	//404 page
	{ path: '*', name: 'Not Found', element: NotFound, accessPermission: [0, 1, 2, 3, 4] },
	
	//403 page
	{ path: '/unauthorized', name: 'Unauthorized', element: NotAccess, accessPermission: [0, 1, 2, 3, 4] }, // Catch-all route for 403
];

export default routes;